import { Hexagon, Triangle, Circle, Square, Diamond, Octagon } from "lucide-react";
import Reveal from "./Reveal";
import { useSite } from "@/context/SiteContext";

const PLACEHOLDER_ICONS = [Hexagon, Triangle, Circle, Square, Diamond, Octagon];

function LogoItem({ item, i }) {
  const Icon = PLACEHOLDER_ICONS[i % PLACEHOLDER_ICONS.length];
  return (
    <div className="mx-12 flex items-center gap-5 flex-shrink-0" data-testid="trusted-logo-item">
      {item.logo_url ? (
        <img src={item.logo_url} alt={item.name} className="h-28 w-auto object-contain" />
      ) : (
        <>
          <Icon size={80} className="text-white" strokeWidth={2} />
          <span className="font-display font-extrabold uppercase text-white text-[54px] tracking-[0.12em] whitespace-nowrap">{item.name}</span>
        </>
      )}
    </div>
  );
}

export default function TrustedBy() {
  const { content } = useSite();
  const logos = content.trusted_logos || [];

  // build a half-track wide enough for a seamless -50% loop on any screen
  const reps = Math.max(1, Math.ceil(1500 / Math.max(1, logos.length * 230)));
  const half = [];
  for (let r = 0; r < reps; r++) half.push(...logos);
  const track = [...half, ...half];

  return (
    <section
      className="py-10 relative overflow-hidden text-white bg-[#04091A]"
      data-testid="trusted-by-section"
    >
      <div className="relative z-10">
        <Reveal direction="up">
          <div className="eyebrow text-[#00CFFF] text-center mb-10">Trusted by brands worldwide</div>
        </Reveal>
        <div className="marquee marquee-continuous relative" data-testid="trusted-marquee">
          <div className="marquee-track items-center">
            {track.map((item, i) => (
              <LogoItem key={item.id + "-" + i} item={item} i={i % Math.max(1, logos.length)} />
            ))}
          </div>
          <div className="absolute inset-y-0 left-0 w-52 pointer-events-none" style={{ background: "linear-gradient(90deg, #04091a, rgba(4,9,26,0))" }} />
          <div className="absolute inset-y-0 right-0 w-52 pointer-events-none" style={{ background: "linear-gradient(270deg, #04091a, rgba(4,9,26,0))" }} />
        </div>
      </div>
    </section>
  );
}
